import React, { useContext } from "react";

import Icon from "../Icon";
import { EligibilityContext } from "../../contexts/EligibilityContext";

const MedicationField = (props) => {
  const context = useContext(EligibilityContext);

  const setMedication = (event, position) => {
    props.setError(""); // remove validation errors
    let medications = [...context.state.medications];
    if (event.target.value) {
      medications[position] = JSON.parse(event.target.value);
    } else {
      medications[position] = "";
    }
    context.actions.setMedications(medications);
  };

  const removeMedication = (position) => {
    // This prevents a user from removing the first, unselected select menu
    if (context.state.medications.length > 1) {
      props.setError(""); // remove validation errors
      let medications = [...context.state.medications];
      medications.splice(position, 1);
      context.actions.setMedications(medications);
    }
  };

  const sortMedsByName = (medications) => {
    return medications.sort(
      (a, b) =>
        (a.Brand_Name.toLowerCase() > b.Brand_Name.toLowerCase()) -
        (a.Brand_Name.toLowerCase() < b.Brand_Name.toLowerCase())
    );
  };

  return (
    <div className={props.className}>
      {context.state.diseaseFund.medications && (
        <div className="MedicationField">
          <label
            className="c-gray-dark"
            htmlFor={`eligibility-med-${props.count}`}
          >
            Medication or service {props.count}
          </label>
          <div className="MedicationField-selectWrapper">
            <select
              onChange={(event) => setMedication(event, props.count - 1)}
              name=""
              id={`eligibility-med-${props.count}`}
              className="MedicationField-select"
              defaultValue={JSON.stringify(props.medication)}
            >
              <option value="">Select</option>
              {sortMedsByName(context.state.diseaseFund.medications).map(
                (medication, i) => (
                  <option key={i} value={JSON.stringify(medication)}>
                    {medication.Brand_Name} ({medication.Generic_Name})
                  </option>
                )
              )}
            </select>
            {context.state.medications.length > 1 && (
              <button
                type="button"
                className="MedicationField-close"
                onClick={() => removeMedication(props.count - 1)}
              >
                <Icon name="closeCircle" width="25" height="25" />
                <span className="u-screenreader">
                  Remove {props.medication.Brand_Name} (
                  {props.medication.Generic_Name})
                </span>
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MedicationField;
